<template>
<div class="creative-banner">
    <!-- 动图创意 -->
    <div class="template">
        <section class="template-body">
            <div v-for="(item,index) in bannerList" class="template-group" :key="index">
                <!-- 删除按钮 -->
                <div class="template-title">
                    <span>模板{{index+1}}</span>
                    <span v-if="(index>0||bannerList.length>1)&&(urlQuery.type!='edit'||!item.id)" @click="deleteTemplate(index)">
                        <Icon title="删除" class="icon-delete" type="android-delete"></Icon>
                    </span>
                </div>
                <!-- 动效 -->
                <div class="panel-row">
                    <p class="panel-row-label">动效{{item.id?`：${animationList[item.animation]}`:''}}</p>
                    <p v-if="!item.id" class="panel-row-radio-group">
                        <cRadio v-for="(value,key) in animationList"
                                @click="onChangeBannerAnimation(index,key)"
                                :status="item.animation==key"
                                :key="key"
                                :label="value" />
                    </p>
                </div>
                <!-- 标题 -->
                <div class="panel-row">
                    <p class="panel-row-label">{{{1:'尺寸',2:'轮播样式'}[item.animation]}}</p>
                    <p class="panel-row-radio-group">
                        <cRadio v-for="(value,key) in bannerSizeList[item.animation]"
                                @click="$set(item,'sizeType',key)"
                                :status="item.sizeType==key"
                                :label="value"
                                :key="key"/>
                    </p>
                </div>
                <!-- 切换速度 -->
                <div v-if="item.animation==1" class="panel-row">
                    <p class="panel-row-label">切换速度</p>
                    <p class="panel-row-radio-group">
                        <cRadio @click="$set(item,'speed',300)"
                                :status="item.speed==300"
                                label="0.3s" />
                        <cRadio @click="$set(item,'speed',500)"
                                :status="item.speed==500"
                                label="0.5s" />
                        <cRadio @click="$set(item,'speed',1000)"
                                :status="item.speed==1000"
                                label="1s" />
                    </p>
                </div>           
                <!-- 切换动画 -->
                <div v-if="item.animation==1" class="panel-row">
                    <p class="panel-row-label">切换动画</p>
                    <p class="panel-row-radio-group">
                        <cRadio @click="$set(item,'transition',0)"
                                :status="item.transition==0"
                                label="无" />
                        <cRadio @click="$set(item,'transition',1)"
                                :status="item.transition==1"
                                label="淡化" />
                    </p>
                </div>

                <!-- 上传多张图片 -->
            <div class="panel-row">
                    <p class="panel-row-label">
                        <span>上传多张图片</span>
                        <span v-if="bannerError.item[index]" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>上传图片尺寸与选择的尺寸不同
                        </span>
                    </p>
                    <div class="banner-img-list">
                        <div v-for="(img,imgIndex) in item.imgList" class="banner-img-item" :key="imgIndex">
                            <!-- 影子元素 -->
                            <input :ref="`bannerImg${index}${imgIndex}`"
                                type="file"
                                hidden
                                accept="image/jpeg,image/jpg,image/png"
                                @change="onFileChange($event,item,'item',imgIndex)" />
                            <!-- 上传中动画 -->
                            <cSpin v-if="img.loading" :size="0.1" :radius="0.05" color="#23c52f" background="#fafafa" />
                            <!-- 缩略图框 -->
                            <div v-else-if="img.imgUrl" @mouseover="$set(img,'function',true)" @mouseout="$set(img,'function',false)" class="item-img-box">
                                <img class="item-img" :src="img.imgUrl"/>
                                <transition name="fade">
                                    <div v-show="img.function" class="img-function">
                                        <span @click="previewImg(img.imgUrl,sizeList[item.sizeType])" class="function-icon"><Icon type="eye"></Icon></span>
                                        <span @click="deleteBannerImg(img,'imgUrl')" class="function-icon"><Icon type="android-delete"></Icon></span>
                                    </div>
                                </transition>
                            </div>
                            <!-- 上传框 -->
                            <div v-else @click="$refs[`bannerImg${index}${imgIndex}`][0].click()" class="item-upload">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">第{{imgIndex+1}}张图</span>
                            </div>
                        </div>
                    </div>               
                    <p class="panel-row-label">要求：尺寸{{sizeList[item.sizeType]}}，单张小于100kb，支持jpg，png</p>
            </div>
                <!-- 上传背景图片 -->
                <div v-if="item.animation==2" class="panel-row">
                    <p class="panel-row-label">
                        <span>上传背景图片</span>
                        <span v-if="bannerError.bg[index]" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>上传图片尺寸与选择的尺寸不同
                        </span>
                    </p>
                    <div class="banner-img-list">
                        <div class="banner-img-item" >
                            <!-- 影子元素 -->
                            <input :ref="`bannerBg${index}`"
                                type="file"
                                hidden
                                accept="image/jpeg,image/jpg,image/png"
                                @change="onFileChange($event,item,'bg')" />
                            <!-- 上传中动画 -->
                            <cSpin v-if="item.bgLoading" :size="0.1" :radius="0.05" color="#23c52f" background="#fafafa" />
                            <!-- 缩略图框 -->
                            <div v-else-if="item.bgUrl" @mouseover="$set(item,'bgFunction',true)" @mouseout="$set(item,'bgFunction',false)" class="item-img-box">
                                <img class="item-img" :src="item.bgUrl"/>
                                <transition name="fade">
                                    <div v-show="item.bgFunction" class="img-function">
                                        <span @click="previewImg(item.bgUrl,sizeList[item.bgSizeType])" class="function-icon"><Icon type="eye"></Icon></span>
                                        <span @click="deleteBannerImg(item,'bgUrl')" class="function-icon"><Icon type="android-delete"></Icon></span>
                                    </div>
                                </transition>
                            </div>
                            <!-- 上传框 -->
                            <div v-else @click="$refs[`bannerBg${index}`][0].click()" class="item-upload">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">背景图片</span>
                            </div>
                        </div>
                    </div>
                    <p class="panel-row-label" style="height:auto">要求：选填，不传则显示默认背景，尺寸{{sizeList[item.sizeType]}}，单张小于100kb，支持jpg，png</p>
                </div>
            </div>
        </section>
        <div v-if="status.action!='edit' || status.type!='creative'" class="template-footer">
            <Button @click="addTemplate" type="info" size="large">
                <p class="btn-long">添加模板</p>
            </Button>
        </div>
    </div>
    <!-- 实时预览 -->
    <div class="preview">
        <div v-if="bannerPreviewList.length" class="preview-detail">
            <cBanner v-if="bannerPreviewList[currentPreview].animation==1" 
                     :offer="bannerPreviewList[currentPreview].offer" 
                     :bannerSize="bannerPreviewList[currentPreview].bannerSize" />
            <iframe v-else :src="bannerPreviewList[currentPreview].url"
                    :style="{ width: `${bannerPreviewList[currentPreview].bannerSize[0]}px`, height: `${bannerPreviewList[currentPreview].bannerSize[1]}px`, display: 'block'}"></iframe>
            <i v-if="bannerPreviewList.length>1 && currentPreview" @click="changePreview('left')" class="left"><Icon type="chevron-left"></Icon></i>
            <i v-if="bannerPreviewList.length>1 && currentPreview<bannerPreviewList.length-1" @click="changePreview('right')" class="right"><Icon type="chevron-right"></Icon></i>
        </div>
        <p v-else class="preview-tip">填写正确完整的信息后将出现预览</p>
    </div>
</div>
</template>
<script>
import mixins from '@/mixins/index';
import cSpin from '@/components/commons/cSpin.vue';
import cBanner from '@/components/commons/cBanner.vue';
import cRadio from '@/components/commons/cRadio.vue';
export default {
    name: 'Banner',
    mixins: [mixins],
    components: { cSpin, cBanner, cRadio },
    data() {
        return {
            //动图动效列表
            animationList: {
                1: '幻灯片',
                2: '轮播',
            },
            currentPreview: 0,
            //动图轮播预览
            urlQuery: this.mixinGetQueryObject(),
        };
    },
    computed: {
        status() {
            return this.$store.state.newPromotion.status;
        },
        bannerList() {
            return this.$store.state.newPromotion.bannerList;
        },
        bannerSizeList() {
            return this.$store.state.newPromotion.bannerSizeList;
        },
        sizeList() {
            return this.$store.state.newPromotion.sizeList;
        },
        bannerTemplate() {
            return this.$store.state.newPromotion.bannerTemplate;
        },
        bannerImgListTemplate() {
            return this.$store.state.newPromotion.bannerImgListTemplate;
        },
        bannerError() {
            return {
                item: this.bannerList.map(item => !item.imgList.every(img => !img.imgUrl || (img.imgUrl && item.sizeType == img.sizeType))),
                bg: this.bannerList.map(item => item.bgUrl && item.bgSizeType != item.sizeType),
            };
        },
        //预览列表
        bannerPreviewList() {
            const error = this.bannerError,
                params = this.bannerList,
                arr = [];
            params.forEach(item => {
                const imgList = item.imgList.filter(item => item.imgUrl);
                //如果上传图片少于2，或者有图片和选择的尺寸不同
                if (!(imgList.length >= 2 && imgList.every(img => img.sizeType == item.sizeType))) return;
                const size = this.sizeList[item.sizeType].split('x');

                if (item.animation == 1) {
                    arr.push({
                        animation: 1,
                        offer: JSON.parse(JSON.stringify(item)),
                        bannerSize: size,
                    });
                }
                if (item.animation == 2) {
                    const rootPath = location.host.includes('localhost') ? '' : '/dist';
                    const url =
                        rootPath +
                        `/static/swiper_new_${this.sizeList[item.sizeType]}.html` +
                        `?imgList=${imgList.map(item => item.imgUrl).join(',')}` +
                        `&bgUrl=${item.bgUrl}`;
                    arr.push({
                        animation: 2,
                        url: url.trim(),
                        bannerSize: size,
                    });
                }
            });
            //通过验证
            if (arr.length < this.currentPreview + 1) this.currentPreview = 0;
            return arr;
        },
    },
    created() {
        //初始化信息流，动图模板
        this.$store.commit('bannerList', [
            {
                ...this.bannerTemplate[1],
                imgList: new Array(3).fill('').map(item => ({ ...this.bannerImgListTemplate })),
            },
        ]);
    },
    methods: {
        /**
         * @desc 删除模板
         * @param {String} type 模板类型
         * @param {String} index 删除的索引
         */
        deleteTemplate(index) {
            this.$store.commit('bannerList', this.bannerList.filter((item, i) => i != index));
        },
        /**
         * @desc 切换预览
         * @param {String} type left or right
         */
        changePreview(type) {
            if (type == 'left') this.currentPreview -= this.currentPreview ? 1 : 0;
            if (type == 'right') this.currentPreview += this.currentPreview != this.bannerPreviewList.length ? 1 : 0;
        },
        /**
         * @desc 切换动图创意动效
         * @param {Number} index 切换的索引
         * @param {Number} animation 切换的动效索引
         */
        onChangeBannerAnimation(index, animation) {
            const bannerList = [...this.bannerList];
            bannerList.splice(index, 1, {
                ...this.bannerTemplate[animation],
                imgList: new Array({ 1: 3, 2: 5 }[animation]).fill('').map(item => ({ ...this.bannerImgListTemplate })),
            });
            this.$store.commit('bannerList', bannerList);
        },
        /**
         * @description 信息流创意上传图片
         * @param {Event} e 原生input事件
         * @param {Object} item 具体的动图创意对象
         * @param {String} type 上传的图片类型：bg or item
         * @param {Number} imgIndex 上传图片的索引，type=='item'下有用
         */
        onFileChange(e, item, type, imgIndex) {
            //记录动效
            const animation = item.animation;
            const files = Array.from(e.target.files);
            //没有选择图片则返回
            if (!files.length) return;

            // 尺寸限制200k
            if (files.some(file => file.size > 1024 * 100)) {
                this.$Message.error({ content: '请上传正确大小的图片', duration: 2 });
                return;
            }
            // 尺寸限制
            const sizeList = { [item.sizeType]: this.bannerSizeList[animation][item.sizeType] };

            this.verifyImgSize(files, sizeList, async sizeList => {
                //开启加载
                if (type == 'item') this.$set(item.imgList[imgIndex], 'loading', true);
                if (type == 'bg') this.$set(item, 'bgLoading', true);

                //上传图片到cdn
                const formData = new FormData();
                files.forEach(file => formData.append('img', file));
                const res = await this.$axios.post(this.$port.manager.uploadImg, formData, { cancelLoading: true });

                //如果上传图片的时候切换了动效
                if (item.animation != animation) return;
                if (type == 'item') {
                    Object.assign(item.imgList[imgIndex], {
                        imgUrl: res.data.urls[0],
                        sizeType: sizeList[0],
                        function: false,
                        loading: false,
                    });
                }
                if (type == 'bg') {
                    Object.assign(item, {
                        bgUrl: res.data.urls[0],
                        bgSizeType: sizeList[0],
                        bgLoading: false,
                        bgFunction: false,
                    });
                }

                e.target.value = '';
            });
        },
        /**
         * @desc 添加模板
         */
        addTemplate() {
            const item = { ...this.bannerTemplate[1] };
            item.imgList = new Array(3).fill('').map(item => ({ ...this.bannerImgListTemplate }));
            this.bannerList.push(item);
        },
        /**
         * @desc 删除banner图片
         * @param {Object} item 要清空的对象
         * @param {String} name 清空的字段
         */
        deleteBannerImg(item, name) {
            this.$set(item, name, '');
            this.$Message.success({ content: '删除成功', duration: 1 });
        },
    },
};
</script>
<style lang="scss">
.creative-banner {
    display: flex;
    justify-content: space-between;
    .preview {
        width: 320px;
        .preview-tip {
            text-align: center;
            margin-top: 0.2rem;
            font-size: 0.14rem;
        }
        &-detail {
            position: relative;

            .left,
            .right {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 0.3rem;
                width: 0.3rem;
                top: 50%;
                transform: translateY(-50%);
                background: #f9f9f9;
                border-radius: 50%;
                border: 1px solid #e0e0e0;
                color: #a0a0a0;
                font-size: 0.14rem;
                cursor: pointer;
            }
            .left {
                left: -0.15rem;
            }
            .right {
                right: -0.15rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/Banner.vue